import { render, staticRenderFns } from "./VxCellImage.vue?vue&type=template&id=2d977e60&"
import script from "./VxCellImage.vue?vue&type=script&lang=js&"
export * from "./VxCellImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports